import React from 'react';
import { CaptionProps, DayPicker, useNavigation } from 'react-day-picker';
import { format } from 'date-fns';

// Types
import { WpDayPickerTypes } from './types';

// Components
import { WpButton } from '../button';
import WpIcon from '../icon/WpIcon';

import 'react-day-picker/dist/style.css';
import './WpDayPicker.scss';

const WpDayPicker = ({
  mode = 'single',
  selected,
  onSelect,
  onMonthChange,
  toDate,
  disabledDays,
  modifiers,
  modifiersClassNames,
}: WpDayPickerTypes): JSX.Element => {
  const baseClassName = 'WpDayPicker';

  const handleOnSelect = value => {
    onSelect && onSelect(value);
  };

  const handlOnMonthChange = value => {
    onMonthChange && onMonthChange(value);
  };

  const CustomCaption = (props: CaptionProps) => {
    const { goToMonth, nextMonth, previousMonth } = useNavigation();

    const handleNextClick = () => {
      goToMonth(nextMonth);
    };

    const handlePreviousClick = () => {
      goToMonth(previousMonth);
    };

    return (
      <div className={`${baseClassName}__caption`}>
        <WpButton
          variant="tertiary"
          size="sm"
          onClick={handlePreviousClick}
          disabled={!previousMonth}
          square
          icon
          qaTest="btn-WpDayPicker-prev"
        >
          <WpIcon name="chevron-left" />
        </WpButton>
        <p className={`${baseClassName}__caption__label`}>{format(props.displayMonth, 'MMMM yyy')}</p>
        <WpButton
          variant="tertiary"
          size="sm"
          onClick={handleNextClick}
          disabled={!nextMonth}
          square
          icon
          qaTest="btn-WpDayPicker-next"
        >
          <WpIcon name="chevron-right" />
        </WpButton>
      </div>
    );
  };

  return (
    <DayPicker
      className="WpDayPicker"
      mode={mode}
      onSelect={handleOnSelect}
      onMonthChange={handlOnMonthChange}
      defaultMonth={selected}
      selected={selected}
      disabled={disabledDays}
      modifiers={modifiers}
      modifiersClassNames={modifiersClassNames}
      toDate={toDate}
      components={{
        Caption: CustomCaption,
      }}
    />
  );
};
export default WpDayPicker;
